
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[categorySlug]/[serviceSlug]",
      function () {
        return require("private-next-pages/services/[categorySlug]/[serviceSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[categorySlug]/[serviceSlug]"])
      });
    }
  